import { memo, MouseEvent } from 'react'

export interface NswFilterCancelProps {
	onReset: (_e: MouseEvent<HTMLButtonElement>) => void
	text?: string
}

const _NswFilterCancel = (props: NswFilterCancelProps) => {
	const { onReset, text } = props
	return (
		<div className="nsw-filters__cancel">
			<button type="reset" onClick={onReset}>
				{text || 'Clear all'}
			</button>
		</div>
	)
}

export const NswFilterCancel = memo(_NswFilterCancel)
